import { render } from "./RecetaInfo.vue?vue&type=template&id=d12a1816&ts=true"
import script from "./RecetaInfo.vue?vue&type=script&lang=ts"
export * from "./RecetaInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__